<p class="about">{{ 'ABOUT_AUTHOR' | translate }}</p>
<div class="content" [class.content--dark]="isDetailRenderModePage()">
  <p class="u-h7 u-anthracite" [innerHTML]="exampleItem.author | nounUpperCase | textOrBlankSpace"></p>
  <p class="u-p3 u-medium-grey" [innerHTML]="exampleItem.department | nounUpperCase | textOrBlankSpace"></p>
  <p class="u-p3 u-medium-grey" [innerHTML]="exampleItem.division_zone | nounUpperCase | textOrBlankSpace"></p>
  <p class="u-p3 u-medium-grey" [innerHTML]="exampleItem.getStoreFullName() | nounUpperCase | textOrBlankSpace"></p>
</div>
